import { T, useTranslate } from '@tolgee/react';
import styled from 'styled-components';

import FrontImage from '../../assets/images/LandingPage/frontImg.png';
import theme from '../../assets/theme';
import HybridForm from '../../components/_organisms/HybridForm/HybridForm';
import { NextPageWithLayout } from '../../components/layouts';
import LandingPageLayout from '../../components/layouts/LandingPageLayout';

const UsageLimitHelpPage: NextPageWithLayout = () => {
  const { t } = useTranslate();
  return (
    <LandingPageLayout
      title={t('Usage Limit Help', 'Usage Limit Help')}
      subTitle={t(
        "Don't Get Set Back by Capacity Limits!",
        "Don't Get Set Back by Capacity Limits!",
      )}
      primaryActionText={t('Usage Limit Help', 'Usage Limit Help')}
      image={FrontImage}
      hideBlobs={false}
      disableHeadline={true}
    >
      <PageContainer>
        <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>
          <T
            keyName="Don't Get Set Back by Capacity Limits!"
            defaultValue="Don't Get Set Back by Capacity Limits!"
          />
        </h1>
        <h4 style={{ textAlign: 'center', marginBottom: '20px' }}>
          <T
            keyName="Love using Curipod? Fill out the form below, and we'll work with your school to ensure you keep access to all AI features"
            defaultValue="Love using Curipod? Fill out the form below, and we'll work with your school to ensure you keep access to all AI features"
          />
        </h4>
        <HybridForm
          showTypeformEnding={true}
          typeformUrl="https://9uq31r57i3q.typeform.com/to/d07MoCI3"
          thankYouMessage={t(
            "Thank you for helping us keep Curipod available for your school! We'll be in touch soon",
            "Thank you for helping us keep Curipod available for your school! We'll be in touch soon.",
          )}
          metricEventNamePrefix="UsageLimitForm"
        />
      </PageContainer>
    </LandingPageLayout>
  );
};

const PageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  background: ${theme.colors.background};
`;

export default UsageLimitHelpPage;
